import { OrganizationSubscriptionV2 } from '../../model/v2/EntitiesV2';
import apiAxiosV2 from './CustomAxiosV2';

class OrganizationSubscriptionApiV2 {
    listAll = async (): Promise<OrganizationSubscriptionV2[]> => {
        const response = await apiAxiosV2.get<OrganizationSubscriptionV2[]>('/organization-subscriptions');

        return response.data;
    };

    get = async (id: number): Promise<OrganizationSubscriptionV2> => {
        const response = await apiAxiosV2.get<OrganizationSubscriptionV2>(`/organization-subscriptions/${id}`);

        return response.data;
    };

    getByOrganizationId = async (organizationId: string): Promise<OrganizationSubscriptionV2> => {
        const response = await apiAxiosV2.get<OrganizationSubscriptionV2>(
            `/organization-subscriptions/organizations/${organizationId}`,
        );

        return response.data;
    };

    create = async (organizationSubscription: OrganizationSubscriptionV2): Promise<OrganizationSubscriptionV2> => {
        const response = await apiAxiosV2.post<OrganizationSubscriptionV2>(
            '/organization-subscriptions',
            organizationSubscription,
        );

        return response.data;
    };

    delete = async (id: number): Promise<void> => {
        await apiAxiosV2.delete(`/organization-subscriptions/${id}`);
    };
}

const organizationSubscriptionApiV2: OrganizationSubscriptionApiV2 = new OrganizationSubscriptionApiV2();
export default organizationSubscriptionApiV2;
